var $ = jQuery;

$( document ).foundation();

$( window ).load( function() {
  /* Preloader */
  $( '.__preloader' ).fadeOut();
  $( 'body' ).removeClass( '__loading' );
} );

$( '.__go_to_top' ).on( 'click', function ( e ) {
  e.preventDefault();
  $( 'html, body' ).animate( { scrollTop: 0 }, 1000 );
} );

$( '.__text_collapse_show' ).on( 'click', function( e ) {
  e.preventDefault();

  if( $( this ).hasClass( '__active_tcs' ) ) {
    $( this ).removeClass( '__active_tcs' );
    $( 'a', this ).text( 'READ MORE' );
  } else {
    $( this ).addClass( '__active_tcs' );
    $( 'a', this ).text( 'READ LESS' );
  }

  var expand_text = $( this ).closest( '.columns' );
  $( '.__text_collapse', expand_text ).slideToggle();
} );

$( '.__table_scroll' ).niceScroll( {
  cursorcolor : '#0093CD',
  cursoropacitymin:1,
  autohidemode:'leave'
} );

$( '.__after_date' ).flatpickr( {
  dateFormat: "d-m-Y",
  minDate: "today"
} );
$( '.__before_date' ).flatpickr( {
  dateFormat: "d-m-Y",
  maxDate: "today"
} );
$( '.__full_date' ).flatpickr( {
  dateFormat: "d-m-Y",
} );

// cookie policy
$( document ).on( 'ready', function() {
  if ( document.cookie.indexOf( 'accepted_cookies=' ) < 0 ) {
    $( '.__cookie' ).fadeIn();
  }

  $( '.__cookie button' ).on( 'click', function() {
    document.cookie = 'accepted_cookies=yes;';
    $( '.__cookie' ).fadeOut();
  } );

  // expand depending on your needs
  $( '.__cookie i' ).on( 'click', function() {
    $( '.__cookie' ).fadeOut();
  } );
} );